import ExchangeRateDataProvider from './ExchangeRateDataProvider';

export default new ExchangeRateDataProvider();
